// Shared formatting for the assessment. Whole dollars everywhere: this is a
// conversation piece, and cents on a seven-figure number read as false
// precision on data the client gave us from memory.

const usd0 = new Intl.NumberFormat('en-US', {
  style: 'currency', currency: 'USD', maximumFractionDigits: 0,
});

export const money = v => (Number.isFinite(v) ? usd0.format(Math.round(v)) : '-');

// Round to the nearest thousand for headline figures, where the extra digits
// suggest a precision the inputs do not have.
export const moneyK = v => {
  if (!Number.isFinite(v)) return '-';
  const abs = Math.abs(v);
  if (abs >= 1000000) return `${v < 0 ? '-' : ''}$${(abs / 1000000).toFixed(abs >= 10000000 ? 1 : 2)}M`;
  if (abs >= 1000) return `${v < 0 ? '-' : ''}$${Math.round(abs / 1000)}K`;
  return money(v);
};

export const pct = (v, digits = 1) =>
  (Number.isFinite(v) ? `${v.toFixed(digits)}%` : '-');
